export const Colors = {
  primary: "#006039",
};
